<template>
  <div>
    <!-- pc -->
    <div class="pc invisible opacity-0 pc:visible pc:opacity-100">
      <header id="header" class="fixed left-0 top-0 z-[2] w-full border-b border-solid border-neutral-200 bg-white">
        <div class="flex items-center px-10">
          <div class="flex-1">
            <div class="logo h-12 flex-none cursor-pointer" @click="registUserInfo.goHome()">
              <img class="h-full w-auto" :src="companyLogo" alt="logo" />
            </div>
          </div>

          <nav class="pc-nav mx-auto max-w-[1200px]">
            <ul class="gnb group flex">
              <li v-if="!isCourseMenuHiddenSite" class="relative text-center">
                <p class="cursor-pointer px-11 py-8 text-lg font-medium text-neutral-950">과정소개</p>
                <ul class="sub invisible absolute z-[3] w-full py-8 opacity-0 group-hover:visible group-hover:opacity-100">
                  <!-- <li @click="goPage('/courseIntroduce/yearly')">
                    <p class="py-3 text-lg font-medium cursor-pointer">연간 과정일정</p>
                  </li> -->
                  <li @click="goJuniorPage()">
                    <p class="cursor-pointer py-3 text-lg font-medium">{{ juniorMenuLabel }}</p>
                  </li>
                  <li v-if="idxLeSiteMain != '127'" @click="goAdultPage()">
                    <p class="cursor-pointer py-3 text-lg font-medium">{{ adultMenuLabel }}</p>
                  </li>
                </ul>
              </li>
              <li class="relative text-center">
                <p class="cursor-pointer px-11 py-8 text-lg font-medium text-neutral-950">수강신청</p>
                <ul class="sub invisible absolute z-[3] w-full py-8 opacity-0 group-hover:visible group-hover:opacity-100">
                  <li v-if="idxLeSiteMain == '52'" @click="openGlobalsugang()">
                    <p class="cursor-pointer py-3 text-lg font-medium">수강신청 하기</p>
                  </li>
                  <li v-else @click="goPage('/enrolment/step')">
                    <p class="cursor-pointer py-3 text-lg font-medium">수강절차 안내</p>
                  </li>
                  <!-- <li @click="registUserInfo.goEnrolment()">
                    <p class="py-3 text-lg font-medium cursor-pointer">수강신청 바로가기</p>
                  </li> -->
                  <li @click="idxLeSiteMain == '52' ? opencheckGlobalsugang() : registUserInfo.goClassList()">
                    <p class="cursor-pointer py-3 text-lg font-medium">수강신청 내역확인</p>
                  </li>
                </ul>
              </li>
              <li class="relative text-center">
                <p class="cursor-pointer px-11 py-8 text-lg font-medium text-neutral-950">학습지원</p>
                <ul class="sub invisible absolute z-[3] w-full py-8 opacity-0 group-hover:visible group-hover:opacity-100">
                  <li @click="goPage('/learningSupport/faq')">
                    <p class="cursor-pointer py-3 text-lg font-medium">FAQ</p>
                  </li>
                  <li @click="goNoticeList()">
                    <p class="cursor-pointer py-3 text-lg font-medium">공지사항</p>
                  </li>
                </ul>
              </li>
              <li @click="registUserInfo.goMyClass('/myClass')" class="relative text-center">
                <p class="cursor-pointer px-11 py-8 text-lg font-medium text-neutral-950">나의 학습방</p>
              </li>
              <li
                v-if="idxLeSiteMain == '52' || isQuestion == 'Y'"
                @click="registUserInfo.goSelfLearning()"
                class="relative text-center"
              >
                <p class="cursor-pointer px-11 py-8 text-lg font-medium text-neutral-950">자기주도학습</p>
              </li>
            </ul>
          </nav>

          <div class="flex flex-1 justify-end">
            <ul v-if="!accessToken" class="flex gap-6">
              <li @click="goPage('/login/login')" class="cursor-pointer text-lg font-medium text-neutral-500">로그인</li>
              <li @click="goPage('/signUp/signUp0')" class="cursor-pointer text-lg font-medium text-neutral-500">회원가입</li>
            </ul>
            <ul v-if="accessToken" class="flex gap-6">
              <li
                v-if="hrInfo.isHr == 'Y'"
                @click="registUserInfo.goToAdminPage()"
                class="cursor-pointer text-lg font-medium text-neutral-500"
              >
                관리자페이지
              </li>
              <li @click="registUserInfo.goToMyPage()" class="cursor-pointer text-lg font-medium text-neutral-500">마이페이지</li>
              <li @click="registUserInfo.getLogout()" class="cursor-pointer text-lg font-medium text-neutral-500">로그아웃</li>
            </ul>
          </div>
        </div>
        <div class="header_bg"></div>
      </header>
    </div>

    <!-- mobile -->
    <div class="mobile pc:invisible pc:opacity-0">
      <header id="header-m" class="fixed left-0 top-0 z-[2] w-full border-b border-solid border-neutral-200 bg-white">
        <div class="mobile-con-wrapper1 flex items-center justify-between py-3">
          <div @click="registUserInfo.goHomeMobile()" class="h-[50px] w-[150px] cursor-pointer overflow-hidden">
            <img :src="companyLogo" alt="logo" class="h-full object-contain" />
          </div>

          <div @click="toggleMobileNav" class="flex-none cursor-pointer">
            <img src="@/assets/images/header/menu-on.png" alt="icon" class="w-5" />
          </div>
        </div>

        <!-- 서브 페이지 들어갈 시 하단 메뉴 노출 -->
        <div v-show="isNavList" class="pb-4 pc:hidden">
          <ul class="flex items-center justify-center gap-5">
            <li class="invisible w-0">&nbsp;</li>
            <li
              @click="onSubMenuClick(menu.path)"
              v-for="(menu, index) in menus"
              :key="index"
              :class="{
                'text-orange-500': isMenuActive(menu.path),
              }"
              class="flex-none cursor-pointer text-sm font-medium text-neutral-950 active:text-orange-500"
            >
              {{ menu.label }}
            </li>
            <li class="invisible w-0">&nbsp;</li>
          </ul>
        </div>

        <nav :class="{ hidden: !isMobileNavOpen }" class="mobile-nav fixed left-0 top-0 h-full w-full bg-white">
          <div class="mobile-con-wrapper1 flex items-center justify-between py-3">
            <div @click="registUserInfo.goHomeMobile()" class="h-[50px] w-[150px] cursor-pointer">
              <img :src="companyLogo" alt="logo" class="h-full object-contain" />
            </div>

            <div @click="toggleMobileNav" class="flex-none cursor-pointer">
              <img src="@/assets/images/header/menu-off.png" alt="icon" class="w-5" />
            </div>
          </div>

          <div class="border-b-8 border-t border-solid border-neutral-100 py-8">
            <ul v-if="!accessToken" class="mobile-con-wrapper1 flex gap-6">
              <li @click="registUserInfo.goLoginMobile()" class="cursor-pointer font-medium text-neutral-500">로그인</li>
              <li @click="registUserInfo.goSignupMobile()" class="cursor-pointer font-medium text-neutral-500">회원가입</li>
            </ul>

            <ul v-if="accessToken" class="mobile-con-wrapper1 flex gap-6">
              <li
                v-if="hrInfo.isHr == 'Y'"
                class="cursor-pointer font-medium text-neutral-500"
                @click="registUserInfo.goToAdminPage()"
              >
                관리자페이지
              </li>
              <li @click="registUserInfo.goToMyPage()" class="cursor-pointer font-medium text-neutral-500">마이페이지</li>
              <li @click="registUserInfo.getLogout()" class="cursor-pointer font-medium text-neutral-500">로그아웃</li>
            </ul>
          </div>

          <ul>
            <li v-if="!isCourseMenuHiddenSite">
              <div
                @click="toggleSubMenu(0)"
                :class="[{ open: subMenuOpen[0] }]"
                class="mobile-con-wrapper1 flex cursor-pointer items-center justify-between border-b border-solid border-neutral-200 py-6"
              >
                <p class="text-lg font-bold text-neutral-950">과정소개</p>
                <div class="flex-none">
                  <img
                    :src="
                      subMenuOpen[0]
                        ? require('@/assets/images/header/arrow-up.png')
                        : require('@/assets/images/header/arrow-down.png')
                    "
                    alt=""
                    class="w-4"
                  />
                </div>
              </div>

              <div class="mobile-sub bg-neutral-100" v-if="subMenuOpen[0]">
                <ul class="mobile-con-wrapper1 flex flex-col gap-5 py-7">
                  <!-- <li
                    class="pc:text-sm font-medium cursor-pointer text-neutral-950 text-[16px]"
                    @click="registUserInfo.goYearlyMobile()"
                  >
                    연간 과정일정
                  </li> -->
                  <li @click="goJuniorPageMobile()" class="cursor-pointer text-[16px] font-medium text-neutral-950 pc:text-sm">
                    {{ juniorMenuLabel }}
                  </li>
                  <li
                    v-if="idxLeSiteMain != '127'"
                    @click="goAdultPageMobile()"
                    class="cursor-pointer text-[16px] font-medium text-neutral-950 pc:text-sm"
                  >
                    {{ adultMenuLabel }}
                  </li>
                </ul>
              </div>
            </li>

            <li>
              <div
                class="mobile-con-wrapper1 flex cursor-pointer items-center justify-between border-b border-solid border-neutral-200 py-6"
                @click="toggleSubMenu(1)"
                :class="[{ open: subMenuOpen[1] }]"
              >
                <p class="text-lg font-bold text-neutral-950">수강신청</p>
                <div class="flex-none">
                  <img
                    :src="
                      subMenuOpen[1]
                        ? require('@/assets/images/header/arrow-up.png')
                        : require('@/assets/images/header/arrow-down.png')
                    "
                    alt=""
                    class="w-4"
                  />
                </div>
              </div>

              <div class="mobile-sub bg-neutral-100" v-if="subMenuOpen[1]">
                <ul class="mobile-con-wrapper1 flex flex-col gap-5 py-7">
                  <li
                    class="cursor-pointer text-[16px] font-medium text-neutral-950 pc:text-sm"
                    v-if="idxLeSiteMain == '52'"
                    @click="openGlobalsugang()"
                  >
                    수강신청 하기
                  </li>
                  <li
                    v-else
                    class="cursor-pointer text-[16px] font-medium text-neutral-950 pc:text-sm"
                    @click="registUserInfo.goStepMobile()"
                  >
                    수강절차 안내
                  </li>
                  <!-- <li
                    class="pc:text-sm font-medium cursor-pointer text-neutral-950 text-[16px]"
                    @click="registUserInfo.goEnrolmentMobile()"
                  >
                    수강신청 바로가기
                  </li> -->
                  <li
                    class="cursor-pointer text-[16px] font-medium text-neutral-950 pc:text-sm"
                    v-if="idxLeSiteMain == '52'"
                    @click="opencheckGlobalsugang()"
                  >
                    수강신청 내역확인
                  </li>
                  <li
                    v-else
                    class="cursor-pointer text-[16px] font-medium text-neutral-950 pc:text-sm"
                    @click="registUserInfo.goClassListMobile()"
                  >
                    수강신청 내역확인
                  </li>
                </ul>
              </div>
            </li>

            <li>
              <div
                class="mobile-con-wrapper1 flex cursor-pointer items-center justify-between border-b border-solid border-neutral-200 py-6"
                @click="toggleSubMenu(2)"
                :class="[{ open: subMenuOpen[2] }]"
              >
                <p class="text-lg font-bold text-neutral-950">학습지원</p>
                <div class="flex-none">
                  <img
                    :src="
                      subMenuOpen[2]
                        ? require('@/assets/images/header/arrow-up.png')
                        : require('@/assets/images/header/arrow-down.png')
                    "
                    alt=""
                    class="w-4"
                  />
                </div>
              </div>

              <div class="mobile-sub bg-neutral-100" v-if="subMenuOpen[2]">
                <ul class="mobile-con-wrapper1 flex flex-col gap-5 py-7">
                  <li
                    class="cursor-pointer text-[16px] font-medium text-neutral-950 pc:text-sm"
                    @click="registUserInfo.goFaqMobile()"
                  >
                    FAQ
                  </li>
                  <li class="cursor-pointer text-[16px] font-medium text-neutral-950 pc:text-sm" @click="goNoticeListMobile()">
                    공지사항
                  </li>
                </ul>
              </div>
            </li>

            <li>
              <div
                class="mobile-con-wrapper1 flex cursor-pointer items-center justify-between border-b border-solid border-neutral-200 py-6"
                @click="registUserInfo.goMyClassMobile('/myClass')"
              >
                <p class="text-lg font-bold text-neutral-950">나의 학습방</p>
              </div>
            </li>

            <li>
              <div
                class="mobile-con-wrapper1 flex cursor-pointer items-center justify-between border-b border-solid border-neutral-200 py-6"
                @click="goSite('https://zoom.us/test')"
              >
                <p class="text-lg font-bold text-neutral-950">Zoom 테스트</p>
              </div>
            </li>

            <li>
              <div
                class="mobile-con-wrapper1 flex cursor-pointer items-center justify-between border-b border-solid border-neutral-200 py-6"
                @click="goSite('https://www.carrotenglish.com/')"
              >
                <p class="text-lg font-bold text-neutral-950">당근영어 성인</p>
              </div>
            </li>

            <li>
              <div
                class="mobile-con-wrapper1 flex cursor-pointer items-center justify-between border-b border-solid border-neutral-200 py-6"
                @click="goSite('https://carrotjunior.kr/')"
              >
                <p class="text-lg font-bold text-neutral-950">당근영어 주니어</p>
              </div>
            </li>

            <li>
              <div
                v-if="idxLeSiteMain == '52' || isQuestion == 'Y'"
                class="mobile-con-wrapper1 flex cursor-pointer items-center justify-between border-t border-solid border-neutral-200 py-6"
                @click="registUserInfo.goSelfLearning()"
              >
                <p class="text-lg font-bold text-neutral-950">자기주도학습</p>
              </div>
            </li>
          </ul>
        </nav>
      </header>
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted, watch, onBeforeMount, computed, reactive } from "vue";
import { useStore } from "vuex";
import axios from "@/plugins/axios.js";
import tracker from "@/plugins/openReplay.js";
import { setReplayUserId } from "@/plugins/sessionReplay.js";

export default {
  components: {},
  props: {},
  setup() {
    // 라우터/스토어 기본 참조
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const idxLeSiteMain = store.state.idxLeSiteMain;
    const isQuestion = store.state.isQuestion;

    // 사용자 상태 기준의 이동/인증 처리 묶음
    const registUserInfo = reactive({
      userLoginInfo: {},

      goToAdminPage() {
        const url =
          process.env.NODE_ENV === "development"
            ? "https://stagehr.carrotenglish.kr/rest/info/login_by_life?encrypted="
            : "https://hr.carrotenglish.kr/rest/info/login_by_life?encrypted=";

        window.open(url + hrInfo.value.hrKey, "_blank");
      },

      goToMyPage() {
        router
          .push({
            path: "/mypage",
          })
          .then(() => {
            isMobileNavOpen.value = false;
          });
      },

      getLogout() {
        axios.get(`/user/auth/logout`).then(function (res) {
          if (res.data.success === true) {
            localStorage.removeItem("LifeEduUserVuex");
            store.commit("setAccessToken", null);
            router.push({ path: "/home" });
            alert("로그아웃 되었습니다.");
          } else {
            alert(res.data.message);
          }
        });
      },

      goHome() {
        // idxLeSiteMain 은 SEO(도메인)·영속 store 로 복구되므로 URL 에 노출하지 않는다
        router.push({ path: "/home" }).then(() => {});
      },

      goHomeMobile() {
        // idxLeSiteMain 은 SEO(도메인)·영속 store 로 복구되므로 URL 에 노출하지 않는다
        router.push({ path: "/home" }).then(() => {
          isMobileNavOpen.value = false;
        });
      },

      goLoginMobile() {
        router
          .push({
            path: "/login/login",
          })
          .then(() => {
            isMobileNavOpen.value = false;
          });
      },

      goSignupMobile() {
        router
          .push({
            path: "/signUp/signUp0",
          })
          .then(() => {
            isMobileNavOpen.value = false;
          });
      },

      goAdultEngMobile() {
        router
          .push({
            path: "/courseIntroduce/adultEng/PageAll",
          })
          .then(() => {
            isMobileNavOpen.value = false;
            isNavList.value = true;
          });
      },

      goJuniorMobile() {
        router
          .push({
            path: "/courseIntroduce/junior",
          })
          .then(() => {
            isMobileNavOpen.value = false;
            isNavList.value = true;
          });
      },

      goStepMobile() {
        router
          .push({
            path: "/enrolment/step",
          })
          .then(() => {
            isMobileNavOpen.value = false;
            isNavList.value = true;
          });
      },

      goEnrolmentMobile() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            tracker.setUserID(store.state.userId);
            setReplayUserId(store.state.userId);

            router
              .push({
                path: "/enrolment/newEnrolment",
              })
              .then(() => {
                isMobileNavOpen.value = false;
              });
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router
              .push({
                path: "/login/login",
              })
              .then(() => {
                isMobileNavOpen.value = false;
              });
          }
        });
      },

      goEnrolment() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            tracker.setUserID(store.state.userId);
            setReplayUserId(store.state.userId);

            router.push({
              path: "/enrolment/newEnrolment",
            });
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router.push({
              path: "/login/login",
            });
          }
        });
      },

      goClassList() {
        const token = store.getters.getAccessToken;
        const isCancleFunction = store.state.isCancleFunction;
        const params = {
          token: token,
          isCancleFunction: isCancleFunction,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            tracker.setUserID(store.state.userId);
            setReplayUserId(store.state.userId);

            router.push({
              path: "/enrolment/classList",
            });
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router.push({
              path: "/login/login",
            });
          }
        });
      },

      goClassListMobile() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            tracker.setUserID(store.state.userId);
            setReplayUserId(store.state.userId);

            router
              .push({
                path: "/enrolment/classList",
              })
              .then(() => {
                isMobileNavOpen.value = false;
              });
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router
              .push({
                path: "/login/login",
              })
              .then(() => {
                isMobileNavOpen.value = false;
              });
          }
        });
      },

      goMyClass() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            tracker.setUserID(store.state.userId);
            setReplayUserId(store.state.userId);

            router.push({
              path: "/myClass",
            });
          } else {
            // 로그인 안 된 경우 alert 없이 바로 로그인 페이지로 이동
            router.push({
              path: "/login/login",
            });
          }
        });
      },

      goMyClassMobile() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            tracker.setUserID(store.state.userId);
            setReplayUserId(store.state.userId);

            router
              .push({
                path: "/myClass",
              })
              .then(() => {
                isMobileNavOpen.value = false;
              });
          } else {
            // 로그인 안 된 경우 alert 없이 바로 로그인 페이지로 이동
            router
              .push({
                path: "/login/login",
              })
              .then(() => {
                isMobileNavOpen.value = false;
              });
          }
        });
      },

      goFaqMobile() {
        router
          .push({
            path: "/learningSupport/faq",
          })
          .then(() => {
            isMobileNavOpen.value = false;
            isNavList.value = true;
          });
      },

      getCheckToken() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            tracker.setUserID(store.state.userId);
            setReplayUserId(store.state.userId);
          } else {
            axios.get(`/user/auth/logout`).then(function (res) {
              if (res.data.success === true) {
                localStorage.removeItem("LifeEduUserVuex");
                store.commit("setAccessToken", null);
              }
            });
          }
        });
      },

      goSelfLearning() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            tracker.setUserID(store.state.userId);
            setReplayUserId(store.state.userId);

            router.push({
              path: "/selfLearning",
            });
            isMobileNavOpen.value = false;
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router.push({
              path: "/login/login",
            });
            isMobileNavOpen.value = false;
          }
        });
      },
    });

    // 외부 수강신청 페이지 이동 전 로그인 상태 확인
    const openGlobalsugang = () => {
      const token = store.getters.getAccessToken;
      const params = {
        token: token,
      };
      axios.get(`/user/auth/token`, { params }).then(function (res) {
        if (res.data.success === true) {
          tracker.setUserID(store.state.userId);
          setReplayUserId(store.state.userId);

          window.location.href = `https://apply.carrotglobal.com/lnk/busanedu?id=${store.state.userId}&accesscode=2024`;
        } else {
          alert("로그인이 필요한 서비스 입니다.");
          router.push({
            path: "/login/login",
          });
        }
      });
    };

    // 외부 수강신청 내역 페이지 이동 전 로그인 상태 확인
    const opencheckGlobalsugang = () => {
      const token = store.getters.getAccessToken;
      const params = {
        token: token,
      };
      axios.get(`/user/auth/token`, { params }).then(function (res) {
        if (res.data.success === true) {
          tracker.setUserID(store.state.userId);
          setReplayUserId(store.state.userId);

          if (location.origin.includes("stage")) {
            window.location.href = "https://stage-itmsugang.carrotenglish.net/lnk/hunitest?loginPageMode=history";
          } else {
            window.location.href = "https://apply.carrotglobal.com/lnk/busanedu?loginPageMode=history";
          }
        } else {
          alert("로그인이 필요한 서비스 입니다.");
          router.push({
            path: "/login/login",
          });
        }
      });
    };

    // 공통 내부 페이지 이동 헬퍼
    const goPage = (path, query) => {
      if (query && Object.keys(query).length > 0) {
        router.push({ path, query });
        return;
      }
      router.push(path);
    };

    // 새 탭 외부 링크 이동
    const goSite = (url) => {
      window.open(url, "_blank");
    };

    const goJuniorPage = () => {
      if (String(idxLeSiteMain) === "138") {
        window.open("https://www.carrotchinese.com/#con4", "_blank");
        return;
      }

      goPage("/courseIntroduce/junior");
    };

    const goJuniorPageMobile = () => {
      if (String(idxLeSiteMain) === "138") {
        window.open("https://www.carrotchinese.com/#con4", "_blank");
        isMobileNavOpen.value = false;
        return;
      }

      registUserInfo.goJuniorMobile();
    };

    const goAdultPage = () => {
      if (String(idxLeSiteMain) === "138") {
        window.open("https://www.carrotenglish.com/curriculum#con-lang", "_blank");
        return;
      }

      goPage("/courseIntroduce/adultEng/PageAll");
    };

    const goAdultPageMobile = () => {
      if (String(idxLeSiteMain) === "138") {
        window.open("https://www.carrotenglish.com/curriculum#con-lang", "_blank");
        isMobileNavOpen.value = false;
        return;
      }

      registUserInfo.goAdultEngMobile();
    };

    // 공지 상세에서 목록 복귀 시 현재 공지 번호 유지
    const currentNoticeIdx = computed(() => route.query.idxNotice ?? "");

    const goNoticeList = () => {
      const query = currentNoticeIdx.value ? { idxNotice: currentNoticeIdx.value } : {};
      goPage("/learningSupport/noticeList", query);
    };

    // 화면 상태값
    const pageTitle = ref("");
    const isMainPage = window.location.pathname === "/home";
    const isNavList = ref(true);

    // 현재 경로 기준으로 하단 서브 메뉴 노출 여부 계산
    const updateIsNavList = () => {
      const currentPath = window.location.pathname;

      // 아래 페이지는 하위 메뉴 안 보여주기
      isNavList.value =
        currentPath !== "/home" &&
        currentPath !== "/login/login" &&
        currentPath !== "/myClass" &&
        currentPath !== "/myPage" &&
        currentPath !== "/signUp/signUp0" &&
        currentPath !== "/signup/signUp1" &&
        currentPath !== "/signUp/signUp1" &&
        currentPath !== "/signup/signUp2" &&
        currentPath !== "/signUp/signUp2" &&
        currentPath !== "/signup/signUp3" &&
        currentPath !== "/signUp/signUp3" &&
        currentPath !== "/selfLearning";
    };
    onBeforeMount(() => {
      updateIsNavList();
    });

    // 모바일 상단 서브 메뉴 원본 정의
    const originalMenus = ref([
      {
        label: "성인 과정",
        path: "/courseIntroduce/adultEng/PageAll",
        group: "menuGroup1",
      },
      {
        label: "주니어 과정",
        path: "/courseIntroduce/junior",
        group: "menuGroup1",
      },
      {
        label: "수강절차 안내",
        path: "/enrolment/step",
        group: "menuGroup2",
      },
      {
        label: "수강신청 바로가기",
        path: "/enrolment/newEnrolment",
        group: "menuGroup2",
      },
      {
        label: "수강신청 내역확인",
        path: "/enrolment/classList",
        group: "menuGroup2",
      },
      { label: "FAQ", path: "/learningSupport/faq", group: "menuGroup3" },
      {
        label: "공지사항",
        path: "/learningSupport/noticeList",
        group: "menuGroup3",
      },
    ]);

    // 현재 경로에 맞는 메뉴 그룹/상태 계산
    const currentPath = computed(() => router.currentRoute.value.path);
    const currentGroup = computed(() => {
      if (currentPath.value.includes("/courseIntroduce")) {
        return "menuGroup1";
      } else if (currentPath.value.includes("/enrolment")) {
        return "menuGroup2";
      } else if (currentPath.value.includes("/learningSupport")) {
        return "menuGroup3";
      }
      return "menuGroup4";
    });
    const accessToken = computed(() => {
      return store.getters.getAccessToken;
    });

    // 특정 사이트는 과정소개 메뉴를 숨김 처리
    const isCourseMenuHiddenSite = computed(() => {
      return ["52", "79", "91"].includes(String(idxLeSiteMain));
    });
    const hrInfo = computed(() => {
      return store.state.hrInfo;
    });
    const companyLogo = computed(() => {
      return store.getters.getCompanyLogo;
    });
    const adultMenuLabel = computed(() => {
      return String(idxLeSiteMain) === "138" ? "일본어 과정" : "성인 과정";
    });
    const juniorMenuLabel = computed(() => {
      return String(idxLeSiteMain) === "138" ? "중국어 과정" : "주니어 과정";
    });
    const filterMenusByGroup = (group) => {
      return originalMenus.value
        .filter((menu) => menu.group === group)
        .map((menu) =>
          menu.path === "/courseIntroduce/junior"
            ? {
                ...menu,
                label: juniorMenuLabel.value,
              }
            : menu.path === "/courseIntroduce/adultEng/PageAll"
              ? {
                  ...menu,
                  label: adultMenuLabel.value,
                }
              : menu
        );
    };
    const menus = computed(() => {
      return filterMenusByGroup(currentGroup.value);
    });
    const isMenuActive = (path) => {
      return currentPath.value === path;
    };

    // 모바일 전체 메뉴/아코디언 제어
    const isMobileNavOpen = ref(false);
    const toggleMobileNav = () => {
      isMobileNavOpen.value = !isMobileNavOpen.value;
    };
    const subMenuOpen = ref([false, false, false]);
    const toggleSubMenu = (index) => {
      for (let i = 0; i < subMenuOpen.value.length; i++) {
        subMenuOpen.value[i] = i === index ? !subMenuOpen.value[i] : false;
      }
    };

    // 모바일 서브 메뉴 클릭 시 예외 경로 처리
    const onSubMenuClick = (path) => {
      if (path === "/learningSupport/noticeList") {
        goNoticeList();
      } else if (String(idxLeSiteMain) === "138" && path === "/courseIntroduce/junior") {
        window.open("https://www.carrotchinese.com/#con4", "_blank");
      } else if (String(idxLeSiteMain) === "138" && path === "/courseIntroduce/adultEng/PageAll") {
        window.open("https://www.carrotenglish.com/curriculum#con-lang", "_blank");
      } else {
        goPage(path);
      }
    };

    const goNoticeListMobile = () => {
      goNoticeList();
      isMobileNavOpen.value = false;
      isNavList.value = true;
    };

    // 마운트 시 페이지 제목과 PC 헤더 hover 동작 초기화
    onMounted(() => {
      if (router.currentRoute.value.meta.title) {
        pageTitle.value = router.currentRoute.value.meta.title;
      } else {
        pageTitle.value = "평생교육";
      }
      watch(
        () => router.currentRoute.value,
        (to, from) => {
          if (to.meta.title) {
            pageTitle.value = to.meta.title;
          } else {
            pageTitle.value = "평생교육";
          }
        }
      );

      // PC GNB hover 시 서브 메뉴 배경/활성 상태 제어
      const gnb = document.querySelector(".gnb");
      const subMenus = document.querySelectorAll(".sub");
      const headerBg = document.querySelector(".header_bg");
      const header = document.getElementById("header");
      const gnbMenus = document.querySelectorAll(".gnb > li");

      // 하위 메뉴 최대 높이 계산
      let maxH = 0;
      subMenus.forEach(function (subMenu) {
        const h = parseInt(window.getComputedStyle(subMenu).height);
        if (h > maxH) {
          maxH = h;
        }
      });

      // 하위 메뉴 마우스 갖다댈 시 이벤트 처리
      gnb.addEventListener("mouseenter", function () {
        headerBg.style.height = maxH + "px";
        header.classList.add("open");
      });

      // 하위 메뉴 마우스 벗어날 시 이벤트 처리
      gnb.addEventListener("mouseleave", function () {
        headerBg.style.height = "0";
        header.classList.remove("open");
      });

      // 하위 메뉴에 마우스 오버 및 리브 시 이벤트 처리
      gnbMenus.forEach(function (gnbItems) {
        gnbItems.addEventListener("mouseenter", function () {
          gnbItems.classList.add("active");

          const subLinks = gnbItems.querySelectorAll(".sub li p");
          subLinks.forEach(function (subItems) {
            subItems.addEventListener("mouseenter", function () {
              subItems.style.color = "#f97316";
            });

            subItems.addEventListener("mouseleave", function () {
              subItems.style.color = "black";
            });
          });
        });

        gnbItems.addEventListener("mouseleave", function () {
          gnbItems.classList.remove("active");
        });
      });
    });

    // 라우트 변경 시 하단 서브 메뉴 노출 상태 동기화
    watch(
      () => route.path,
      (nVal, oVal) => {
        updateIsNavList();
      }
    );
    return {
      idxLeSiteMain,
      isQuestion,
      currentRoute: route,
      goPage,
      goSite,
      goAdultPage,
      goAdultPageMobile,
      goJuniorPage,
      goJuniorPageMobile,
      goNoticeList,
      onSubMenuClick,
      goNoticeListMobile,
      registUserInfo,
      accessToken,
      isCourseMenuHiddenSite,
      hrInfo,
      companyLogo,
      adultMenuLabel,
      juniorMenuLabel,
      openGlobalsugang,
      opencheckGlobalsugang,
      isMainPage,
      pageTitle,
      isNavList,
      menus,
      isMenuActive,
      isMobileNavOpen,
      toggleMobileNav,
      subMenuOpen,
      toggleSubMenu,
    };
  },
};
</script>

<style scoped>
.pc #header.open .header_bg {
  position: absolute;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  border-top: 1px solid #e5e5e5;
  z-index: 1;
  padding-bottom: 150px;
}

.pc #header .pc-nav .active:hover:after {
  content: "";
  display: block;
  width: 100%;
  height: 3px;
  background: #f97316;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>
